import type DayOfWeek from 'owa-service/lib/contract/DayOfWeek';
import type WorkDay from '../constants/workDay';

const mapDayOfWeek = (day: DayOfWeek): string => {
    switch (day) {
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        case 6:
            return 'Saturday';
        case 0:
            return 'Sunday';
    }
};

export default mapDayOfWeek;
